<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <page-heading :heading="evaluation.name">
      <span slot="before">
         <back-link style="margin-bottom: 5px" :link="{ name: 'EvalMyEvaluations' }" text="В мои оценки 360"></back-link>
      </span>
    </page-heading>
    <div>
      <el-tabs value="description">
        <el-tab-pane label="Описание оценки" name="description">
          <el-card>
            <div v-loading="loading">
              <div v-if="evaluation.status_label">
                <p><b>Статус оценки:</b> {{ evaluation.status_label.toLowerCase() }}</p>
                <p><b>Описание оценки:</b> <span v-if="!evaluation.description">описание не задано</span></p>
                <div v-if="evaluation.description" v-html="evaluation.description"></div>
              </div>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-if="evaluation.status && evaluation.status === 'started'" :label="'Я оцениваю ' + totalEvaluatorCount.evaluated_count + '/' + totalEvaluatorCount.all_count" name="evaluator">
          <el-card>
            <my-evaluators @refresh-eval-user="getEvaluationUser" @refresh-evaluatee="refreshEvaluatee" :evaluation="evaluation" @update-total-count="totalEvaluatorCount = $event"></my-evaluators>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-if="Object.keys(evaluation_user).length && evaluation.status && evaluation.status !== 'finished' && evaluation.setting.is_colleague" :label="'Выбор коллег ' + totalColleagueCount" name="colleague">
          <el-card>
            <addition-colleagues @refresh-evaluatee="refreshEvaluatee" :evaluation="evaluation" @update-total-count="totalColleagueCount = $event"></addition-colleagues>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-if="Object.keys(evaluation_user).length && evaluation.setting && evaluation.setting.show_evaluator && evaluation.status && evaluation.status !== 'created'" :label="'Меня оценивают ' + totalEvaluateeCount.evaluated_count + '/' + totalEvaluateeCount.all_count" name="evaluatee">
          <el-card>
            <my-evaluatees ref="myEvaluatee" @update-total-count="totalEvaluateeCount = $event" :evaluation="evaluation"></my-evaluatees>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-if="evaluation.setting && evaluation.setting.show_result && (evaluation_user.status === 'done' || (evaluation.status && evaluation.status === 'finished'))" label="Результат оценки" name="result">
          <el-card>
            <my-evaluation-result
              :userId="user.id"
              :evaluationId="evaluation.id"
            ></my-evaluation-result>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import AdditionColleagues from "@/modules/evaluation/components/myEvaluation/AdditionColleagues.vue";
import MyEvaluatees from "@/modules/evaluation/components/myEvaluation/MyEvaluatees.vue";
import MyEvaluators from "@/modules/evaluation/components/myEvaluation/MyEvaluators.vue";
import MyEvaluationResult from "@/modules/evaluation/components/myEvaluation/MyEvaluationResult.vue";
import {mapGetters} from "vuex";
import BackLink from "@/components/BackLink.vue";

export default {
  name: 'eval-my-evaluation',
  components: {
    BackLink,
    MyEvaluationResult,
    PageHeading,
    AdditionColleagues,
    MyEvaluatees,
    MyEvaluators,
  },
  computed:{
    ...mapGetters(['user'])
  },
  data() {
    return {
      loading: false,
      totalColleagueCount: 0,
      evaluation_user: {},
      totalEvaluateeCount: {
        all_count: 0,
        evaluated_count: 0,
      },
      totalEvaluatorCount: {
        all_count: 0,
        evaluated_count: 0,
      },
      evaluation: {
        type: Object,
        default: {},
      },
    }
  },
  mounted() {
    this.getEvaluation();
    this.getEvaluationUser();
  },
  methods: {
    getEvaluation() {
      this.loading = true;
      this.$api.evaluation.myEvaluationGet({
        id: this.$route.params.id,
      })
        .then(data => {
          this.evaluation = data.evaluation;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getEvaluationUser() {
      this.$api.evaluation.evaluationUserGet({
        evaluation_id: this.$route.params.id,
        user_id: this.user.id,
      })
        .then(data => {
          if (data.evaluation_user !== null) {
            this.evaluation_user = data.evaluation_user;
          }
        })
    },
    refreshEvaluatee() {
      if (this.$refs.myEvaluatee) {
        this.$refs.myEvaluatee.loadEvaluatees();
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>